
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 2C8.66 2 5.71 3.72 5.76 8.16l-3.72 4.82c-.11.14.02.32.22.32l2.48 1.23c.13.92.61 3.6.87 4.94.09.42 4.19.1 4.19.1L11 22","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.845 2.202a.6.6 0 00-1.13-.404l-1.02 2.85a.6.6 0 101.13.404l1.02-2.85zm6.204 3.018a.6.6 0 00-.719-.96l-3.42 2.56a.6.6 0 10.72.96l3.42-2.56zm-3.918 6.606a.6.6 0 01.642-.554l3.27.24a.6.6 0 11-.087 1.197l-3.27-.24a.6.6 0 01-.555-.643zM11.72 17.31a.6.6 0 000 1.2h2.63a.6.6 0 100-1.2h-2.63zm-.6-1.98a.6.6 0 01.6-.6h.16c-1.32-1.107-3.126-3.537-1.65-5.48 1.44-1.89 4.17-1.89 5.61 0 1.474 1.941-.32 4.374-1.642 5.48h.152a.6.6 0 010 1.2h-2.63a.6.6 0 01-.6-.6zm2.52-.6v-2.555A1.099 1.099 0 0013 10.18a1.1 1.1 0 00-.56 2.047v2.503h1.2zm-.667-3.546z","fill":"#fff","fill-opacity":".6"}})])
          )
        }
      }
    